import styled from "styled-components";

export const Container = styled.section`
  padding: 38px 40px;
  background-color: ${({ theme }) => theme.old.colors.background.creators};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: ${({ theme }) => `calc(100vh - 76px - ${theme.old.sizes.header})`};

  ${({ theme }) => theme.old.breakpoints.isTab} {
    padding: 38px 16px;
  }
`